import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import { NgIf } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { DateTransformPipe } from '../../pipes/date-transform.pipe';

@Component({
    selector: 'slm-last-update',
    templateUrl: './last-update.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf, TranslatePipe, DateTransformPipe]
})
export class LastUpdateComponent {

  @Input() date: Date | string;
  @Input() marginBottom: string;
  @Input() fullWidth = false;
}
